var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"note"},[_c('el-col',{staticClass:"v-ml-10",attrs:{"span":8}},[_vm._v(" "+_vm._s(_vm.$route.meta.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }